import { UploadFile } from "antd";
import SkTechApiClient from "./base/SkTechApiClient";
import { ResourceItem, ResourceType } from "../stores/ResourcesStore";
import { RcFile } from "antd/es/upload";


export default class UserResourceApi extends SkTechApiClient {

  public getAll = async (): Promise<ResourceItem[]> => {
    return await this.Get(`/api/UserResource`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public getAllGroups = async (): Promise<ResourceType[]> => {
    return await this.Get(`/api/UserResource/Groups`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public add = async (item: ResourceItem): Promise<any> => {
      return await this.Post(`/api/UserResource`, item)
        .then(function (response) {
          if (response.data) {
            return response.data;
          }
          return false;
        });
    }

    public addGroups = async (title: string): Promise<any> => {
      return await this.Post(`/api/UserResource/Groups`, {
        title: title
      })
        .then(function (response) {
          if (response.data) {
            return response.data;
          }
          return false;
        });
    }
    
    public update = async (id: number, item: any): Promise<any> => {
      return await this.Patch(`/api/UserResource/${id}`, item)
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          }
          return false;
        });
    }

    public delete = async (id: number): Promise<any> => {
      return await this.Delete(`/api/UserResource/${id}`)
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          }
          return false;
        });
    }

     public uploadAttachment = async (
        file: UploadFile,
        id: string,
        confirmation: boolean = false
      ): Promise<any> => {
        const formData = new FormData();
        formData.append("file", file as RcFile);
      
        const url = confirmation 
            ? `/api/File/UploadUserResourceAttachment?userResourceId=${id}&confirmation=true`
            : `/api/File/UploadUserResourceAttachment?userResourceId=${id}`;
    
        return await this.Post(url, formData);
      };
  
}